/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SearchLoupeIcon24Regular = forwardRef('SearchLoupeIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.995 1.503a9.492 9.492 0 0 0 0 18.984 9.455 9.455 0 0 0 6.161-2.27l4.326 4.326a.75.75 0 1 0 1.06-1.06l-4.325-4.327a9.455 9.455 0 0 0 2.27-6.16 9.492 9.492 0 0 0-9.492-9.493Zm-7.992 9.492a7.992 7.992 0 1 1 15.985 0 7.992 7.992 0 0 1-15.985 0Z" })));
});
